export default __webpack_public_path__ + "static/media/mern1.8b1bd0e9.jpg";